import { PropertyMatrixSharedService } from 'src/app/property-matrix-shared.service';
import { UserService } from 'src/app/services/user.service';
import {AfterViewInit, Component, OnInit} from '@angular/core';
import { User } from 'src/app/models/User';
import { first } from 'rxjs/operators';
import {MatDialog} from '@angular/material/dialog';
import { HomeDialogComponent } from './dialog/home-dialog.component';
import {UserManagementService} from "src/app/services/property-matrixV2/services/user-management.service";
import {NotificationService} from "src/app/shared/services/notification-service/notification.service";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, AfterViewInit {

  user: User;

  constructor(
    private userService: UserService,
    private authService: PropertyMatrixSharedService,
    public dialog: MatDialog,
    private userManagementService: UserManagementService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    if (!this.user) {
      return;
    }
    if (this.user.userID == null) {
      this.user = this.authService.userValue;
    }
    this.userService
      .getById(this.user.userID)
      .pipe(first())
      .subscribe(user => {
        this.user = user;
      });
  }

  ngAfterViewInit(): void {
      if (sessionStorage.getItem('loadedWelcomePopup') == null) {
        sessionStorage.setItem('loadedWelcomePopup', 'true');
        const dialogRef = this.dialog.open(HomeDialogComponent);

        dialogRef.afterClosed().subscribe(() => {
          this.checkEndorsementStatus();
        });
      }else {
        this.checkEndorsementStatus();
      }
  }

  checkEndorsementStatus(): void {
    this.userManagementService.apiV1UserManagementGetCurrentUserGet().subscribe(result => {
      if (result != null && result.endorsed !== true) {
        this.notificationService.showWarningMessage('Endorsement', 'You have not yet been endorsed by the Property Matrix team.');
      }
    });
  }
}
